const images = {
  mounted() {
    const video1 = document.createElement('video')
    const video2 = document.createElement('video')
    const video3 = document.createElement('video')
    const video4 = document.createElement('video')

    video2.setAttribute('src', require('@/assets/images/gif-moro.mp4'))
    video1.setAttribute('src', require('@/assets/images/cartas-de-amor.mp4'))
    video3.setAttribute('src', require('@/assets/images/negacionismo.mp4'))
    video4.setAttribute('src', require('@/assets/images/torturas.mp4'))
    video1.style.display = 'none'
    video2.style.display = 'none'
    video3.style.display = 'none'
    video4.style.display = 'none'
    document.body.appendChild(video2)
    document.body.appendChild(video1)
    document.body.appendChild(video3)
    document.body.appendChild(video4)

    const image0 = new Image()
    const image1 = new Image()
    const image2 = new Image()
    const image3 = new Image()
    const image4 = new Image()
    const image5 = new Image()
    const image6 = new Image()
    const image7 = new Image()
    const image8 = new Image()
    const image9 = new Image()
    const image10 = new Image()
    const image11 = new Image()
    const image12 = new Image()
    const image13 = new Image()
    const image14 = new Image()
    const image15 = new Image()
    const image16 = new Image()

    image0.src = require('@/assets/images/infovirus-logo.png')
    image1.src = require('@/assets/images/memorial2.png')
    image2.src = require('@/assets/images/memorial3.png')
    image3.src = require('@/assets/images/memorial5.png')
    image4.src = require('@/assets/images/carrossel1.jpg')
    image5.src = require('@/assets/images/carrossel2.jpg')
    image6.src = require('@/assets/images/carrossel3.jpg')
    image7.src = require('@/assets/images/carrossel4.jpg')
    image8.src = require('@/assets/images/carrossel5.png')
    image9.src = require('@/assets/images/carrossel6.jpg')
    image10.src = require('@/assets/images/carrossel7.jpg')
    image11.src = require('@/assets/images/carrossel8.jpg')
    image12.src = require('@/assets/images/carrossel9.jpg')
    image13.src = require('@/assets/images/cartas1.jpeg')
    image14.src = require('@/assets/images/cartas2.jpeg')
    image15.src = require('@/assets/images/mapa-1.png')
    image16.src = require('@/assets/images/sangue.webp')
  },
}

export default images
